import React, { useState } from 'react'
import { EditDelWrapper, ItemTitle } from '../dashboard.styled'
import { DeleteFilled, DownloadOutlined, EditFilled, Loading3QuartersOutlined, ReloadOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import { downloadDashboardData } from '../../../apis/dashboard'

function ChartHeader (props) {
  const { data, settingMode, actions, allowRefresh, refreshLoading } = props
  const { title, colId, ruleType, updateInfo, id, content, groupId, brandId, tableName, categoryDetail } = data || {}
  const { handleEdit, handleDelete, handleRefresh } = actions
  const [downloadLoading, setDownloadLoading] = useState(false)

  const onDownload = (src, name) => {
    const url = src
    const link = document.createElement('a')
    link.href = url
    link.download = name
    document.body.appendChild(link)
    link.click()
    URL.revokeObjectURL(url)
    link.remove()
  }

  const handleDownload = async () => {
    setDownloadLoading(true)
    const reqBody = { id, groupId, brandId, tableName, categoryDetail }
    const res = await downloadDashboardData(reqBody)
    if (res?.status === 200) {
      const src = window.URL.createObjectURL(new Blob([res?.data]))
      const disposition = res.headers['content-disposition']
      const fileName = disposition && disposition.includes('filename=')
        ? decodeURIComponent(disposition.split('filename=')[1].replace(/"/g, ''))
        : data?.name
      onDownload(src, `${fileName}.xlsx`)
    }
    setDownloadLoading(false)
  }

  return <ItemTitle>
    {title}
    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
      {settingMode
        ? <EditDelWrapper>
            <div><EditFilled onClick={() => handleEdit(colId, ruleType, 'edit', data)}/></div>
            <div><DeleteFilled onClick={() => handleDelete(data)}/></div>
          </EditDelWrapper>
        : updateInfo}
      {allowRefresh && <Button
        style={{ width: 'fit-content', height: 'fit-content', padding: '4px', marginTop: '-2px', marginLeft: '4px' }}
        icon={refreshLoading === id ? <Loading3QuartersOutlined spin style={{ fontSize: '12px' }} /> : <ReloadOutlined style={{ fontSize: '12px' }}/>}
        onClick={() => handleRefresh(data)}
      />}
      {!settingMode && <Button
        style={{ width: 'fit-content', height: 'fit-content', padding: '4px', marginTop: '-2px' }}
        icon={downloadLoading ? <Loading3QuartersOutlined spin style={{ fontSize: '12px' }} /> : <DownloadOutlined style={{ fontSize: '12px' }}/>}
        onClick={handleDownload}
        disabled={content?.status !== 'done'}
      />}
    </div>
  </ItemTitle>
}

export default ChartHeader
